import { ConfigurationFeatures } from './ConfigurationFeatures';
export class ConfigMenuController {
    constructor() { }
    async $onInit() {
        this.isTokenManagementEnable = await ConfigurationFeatures.isTokenManagementEnable();
        this.isMimeTypeManagementEnable = await ConfigurationFeatures.isMimeTypeManagementEnable();
    }
}
